import React from 'react';

export interface LinkProps {
  children: React.ReactNode;
  href: string;
  className?: string;
}

export const Link: React.FC<LinkProps> = ({ children, href, className = '' }) => {
  return (
    <a href={href} className={className}>
      {children}
    </a>
  );
};

export const PrimaryLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`text-blue-600 hover:text-blue-800 ${props.className || ''}`} />
);

export const SecondaryLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`text-gray-600 hover:text-gray-800 ${props.className || ''}`} />
);

export const TextLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`text-current underline ${props.className || ''}`} />
);

export const ButtonLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 ${props.className || ''}`} />
);

export const NavLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`text-gray-600 hover:text-gray-800 px-3 py-2 rounded ${props.className || ''}`} />
);

export const BreadcrumbLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`text-gray-500 hover:text-gray-700 text-sm ${props.className || ''}`} />
);

export const SocialLink: React.FC<LinkProps> = (props) => (
  <Link {...props} className={`text-gray-600 hover:text-gray-800 ${props.className || ''}`} />
);

export default Link;
